import { render } from "./QuestionFour.vue?vue&type=template&id=6e4273cb&scoped=true"
import script from "./QuestionFour.vue?vue&type=script&lang=js"
export * from "./QuestionFour.vue?vue&type=script&lang=js"

import "./QuestionFour.vue?vue&type=style&index=0&id=6e4273cb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4273cb"]])

export default __exports__